import { Box, ResponsiveValue, Text } from '@chakra-ui/react';
import React from 'react';

type FlexDirection = 'row' | 'column';

type IconTileProps = {
  onIconTileClick: () => void;
  title: string;
  icon: React.ReactElement;
  iconDirection: ResponsiveValue<FlexDirection>;
};

const IconTile = ({ onIconTileClick, title, icon, iconDirection }: IconTileProps) => {
  return (
    <Box
      onClick={onIconTileClick}
      display='flex'
      justifyContent='center'
      alignItems='center'
      flexDirection={iconDirection}
      gap={iconDirection === 'column' ? 2 : 4}
      border='1px solid #A3A3A3'
      padding={[3, 5]}
      borderRadius={[10, 20, 30]}
    >
      {React.cloneElement(icon, { color: 'primary.black', fontSize: '24px' })}
      <Text color='primary.black' fontWeight={600} fontSize='14px'>
        {title}
      </Text>
    </Box>
  );
};

export { IconTile };
